import React from 'react';
import { Logo } from './Logo';
const PHONE = '586-203-3701';
export function Header() {
  return <header className="w-full bg-white border-b border-slate-200 sticky top-0 z-40 shadow-sm" data-id="element-125" data-mp="2dluqsp1k3jss">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 sm:py-6 flex items-center justify-between gap-4" data-id="element-126" data-mp="2ikxvg8dmjo08">
        <a href="#top" className="flex items-center gap-3 flex-shrink-0" data-id="element-127" data-mp="2nlllaqq49ysv">
          <Logo size={130} data-id="element-128" data-mp="2rmfd3v6ojxr1" />
        </a>

        <div className="flex items-center gap-3" data-id="element-129" data-mp="2rlmbt9qhq0ga">
          <a href={`tel:${PHONE.replace(/-/g, '')}`} className="hidden md:block text-[#1a2332] font-bold text-lg hover:text-[#2DB8E0] transition-colors" data-id="element-130" data-mp="2wkywpoxswxg8">
            {PHONE}
          </a>
          <a href="#quote-form" className="inline-flex items-center bg-[#2DB8E0] hover:bg-[#1a9cc4] text-white font-bold px-5 sm:px-7 py-3 rounded-full transition-all shadow-md hover:shadow-lg text-sm sm:text-base whitespace-nowrap" data-id="element-131" data-mp="36bbg3dtvqkks">
            <span className="hidden sm:inline mr-2" data-id="element-132" data-mp="2wkuor0melv9g">—</span>
            Book An Appointment
            <span className="hidden sm:inline ml-2" data-id="element-133" data-mp="2rlrhramv5eyu">—</span>
          </a>
        </div>
      </div>
    </header>;
}